
import { createContext, useState, useEffect } from "react";
import { useParams, useSearchParams, useNavigate, useLocation } from 'react-router';

import { checkParams } from 'src/util/Util';

const SearchContext = createContext();

const newDate = () => {
    return new Date().toLocaleString('es', {day:"2-digit", year:"numeric", month:"2-digit", hour:"2-digit", minute:"2-digit", second: "2-digit", fractionalSecondDigits: 3});
}

const SearchProvider = ({children}) => {

    const { id } = useParams();
    const [ searchParams, setSearchParams ] = useSearchParams();
    const navigate = useNavigate();
    const location = useLocation();

    const [ isSearching, setIsSearching ] = useState(checkParams(searchParams));


    const [ openFilter, setOpenFilter ] = useState(false);
    const [ openMenu, setOpenMenu ] = useState(false);
    const [ total, setTotal ] = useState(0);


    const updateParams = (searchParams) => {
        const currentPath = location.pathname;
        const hasParams = searchParams.size > 0;

        // redireccionamos a /, cuando hay cambios en lo filtros de búsqueda
        if (currentPath !== '/' && hasParams) {
            // console.log('Redirecting from:', currentPath, searchParams);
            navigate(`/?${searchParams.toString()}`);
        } else {
            setSearchParams(searchParams)
        }
    }

    useEffect(() => {
        // console.log('SearchContext on searchParams:', location.pathname, searchParams);
        setIsSearching(checkParams(searchParams) );
        setOpenMenu(false)
    }, [searchParams, location.pathname, navigate, location.state, id]);


    return (
        <SearchContext.Provider
            value={{ openFilter, setOpenFilter, openMenu, setOpenMenu, isSearching, total, setTotal, updateParams }}
        >
            { children }
        </SearchContext.Provider>
    );
}

export { SearchProvider };

export default SearchContext;
